import React, { useEffect, useState } from 'react'

import {
  royalFlush,
  straightFlush,
  fourOfAKind,
  fullHouse,
  flush,
  straight,
  threeOfAKind,
  twoPairs,
  onePair,
  highCard,
} from './Combinations'

export const useCardCombinations = (coefs: any) => {
  const [combArray, setCombArray] = useState<any[]>([])
  useEffect(() => {
    coefs.coefs &&
      setCombArray([
        {
          combinationName: 'Royal flush',
          coef: coefs.coefs[9],
          cards: royalFlush,
        },
        {
          combinationName: 'Straight flush',
          coef: coefs.coefs[8],
          cards: straightFlush,
        },
        {
          combinationName: 'Four of a kind',
          coef: coefs.coefs[7],
          cards: fourOfAKind,
        },
        {
          combinationName: 'Full house',
          coef: coefs.coefs[6],
          cards: fullHouse,
        },
        {
          combinationName: 'Flush',
          coef: coefs.coefs[5],
          cards: flush,
        },
        {
          combinationName: 'Straight',
          coef: coefs.coefs[4],
          cards: straight,
        },
        {
          combinationName: 'Three of a kind',
          coef: coefs.coefs[3],
          cards: threeOfAKind,
        },
        {
          combinationName: 'Two Pairs',
          coef: coefs.coefs[2],
          cards: twoPairs,
        },
        {
          combinationName: 'One Pair',
          coef: coefs.coefs[1],
          cards: onePair,
        },
        {
          combinationName: 'High Card',
          coef: coefs.coefs[0],
          cards: highCard,
        },
      ])
  }, [coefs.coefs])

  return [combArray]
}
